import {Fragment} from "react";
import {useTranslation} from "react-i18next";
import {useParams} from "react-router-dom";
import {useArticle, useArticles} from "../hooks/use-articles";

import Container from "../сomponents/UI/Container";
import Header from "../сomponents/section/Header/Header";
import PageHeader from "../сomponents/UI/header/PageHeader";
import SectionHeaderSmall from "../сomponents/UI/header/SectionHeaderSmall";
import NewsShowcase from "../сomponents/section/NewsShowcase";
import ContentLoadingSpinner from "../сomponents/UI/loading/ContentLoadingSpinner";
import TextLoading from "../сomponents/UI/loading/TextLoading";

import './NewsPage.sass'

const NewsPage = () => {
    const { t } = useTranslation();
    const params = useParams();

    const article = useArticle(params.slug);
    let articles = useArticles();

    let articleTitle = <TextLoading />;
    let articleContent = <ContentLoadingSpinner />;
    if (article) {
        articleTitle = article.title;
        articleContent = <article className="news-body" dangerouslySetInnerHTML={{__html: article.content}}></article>;
    }

    let showcase = <ContentLoadingSpinner />;
    if (articles.length > 0) {
        articles = articles.filter(article => article.slug !== params.slug).slice(0, 4);
        showcase = <NewsShowcase newsInfo={articles} />;
    }
// TODO вынести spinner в папку
    return (
        <Fragment>
            <Header home={false} />
            <main>
                <PageHeader>
                    {articleTitle}
                </PageHeader>
                <Container>
                    {articleContent}

                    <SectionHeaderSmall>{t("newsroom.otherArticlesGalleryHeader")}</SectionHeaderSmall>
                    {showcase}
                </Container>
            </main>
        </Fragment>
    );
};

export default NewsPage;